// extracted by mini-css-extract-plugin
export default {"listViewGrid":"DealListPage_listViewGrid__85not","tableContainer":"DealListPage_tableContainer__OpYzb"};